import PortOperatorLicenseRequestPage from "@features/licensing/license-details/flow/request-port-operator-license/PortOperatorLicenseRequestPage";
import VendorLicenseRenewalPage from "@features/licensing/license-details/flow/request-vendor-license-renewal/VendorLicenseRenewalPage";
import LicenseDetails from "@features/licensing/license-details/LicenseDetails";
import LicensesContainer from "@features/licensing/LicensesContainer";
import LicensesPage from "@pages/licensing/LicensesPage";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

const buildLicensesRoute = (path: string): AppRoute => ({
  path,
  protected: true,
  element: <LicensesPage />,
  children: [
    { index: true, element: <LicensesContainer /> },
    {
      path: paths.licenses.licenseDetailsById,
      element: <LicenseDetails />,
    },
    {
      path: paths.licenses.licenseDetails,
      element: <LicenseDetails />,
    },
    {
      path: paths.licenses.portOperatorLicenseRequest,
      element: <PortOperatorLicenseRequestPage />,
    },
    {
      path: paths.licenses.vendorLicenseRenewal,
      element: <VendorLicenseRenewalPage />,
    },
    {
      path: paths.licenses.portOperatorLicenseRenewal,
      element: <PortOperatorLicenseRequestPage />,
    },
  ],
});

export const getLicensesRoutes = (): AppRoute => buildLicensesRoute(paths.licenses.index);

export const getAccountsRoutes = (): AppRoute => buildLicensesRoute(paths.licenses.accountIndex);

export const getPortOperatorLicensesRoutes = (): AppRoute =>
  buildLicensesRoute(paths.licenses.portOperatorIndex);
